import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { useMutation } from '@apollo/client'
import { UPDATE_TASK_MUTATION } from '../query/gqlQueries.js'
import { GripVertical, Edit2 } from 'lucide-react' // Import icons
import './TaskCard.scss'

export function TaskCard({ task, isOverlay, onEditTask }) {
  const { setNodeRef, attributes, listeners, transform, transition, isDragging } = useSortable({
    id: task.id,
    data: { type: 'Task', task }
  })

  const [updateTask] = useMutation(UPDATE_TASK_MUTATION)

  const style = {
    transition,
    transform: CSS.Translate.toString(transform)
  }

  const handleAddTime = async () => {
    const currentTimeSpent = Number(task.properties.timeSpent) || 0
    const newTimeSpent = currentTimeSpent + 0.5
    try {
      await updateTask({
        variables: {
          identity: task.id,
          input: { timeSpent: newTimeSpent }
        }
      })
      console.log('Task updated successfully')
    } catch (error) {
      console.error('Error updating task:', error)
    }
  }

  return (
    <div ref={setNodeRef} style={style} className={`task-card ${isDragging ? 'dragging' : ''} ${isOverlay ? 'overlay' : ''}`}>
      {/* Drag handle with listeners and attributes */}
      <div className="drag-handle" {...attributes} {...listeners} aria-label={`Move task: ${task.content}`}>
        <GripVertical size={16} />
      </div>
      <div className="task-content">{task.content}</div>
      <button
        onClick={(e) => {
          e.stopPropagation()
          if (onEditTask) onEditTask(task)
        }}
        className="add-time-button">
        <Edit2 size={14} />
      </button>
    </div>
  )
}
